import React from 'react';
import ChamadoHeader from './ChamadoHeader';
import ChamadoDescription from './ChamadoDescription';
import ChamadoEditor from './ChamadoEditor';
import ChamadoTimeline from './ChamadoTimeline';
import ChamadoSidebarSolicitante from './ChamadoSidebarSolicitante';
import './ChamadoPage.css';

function ChamadoPageSolicitante({
    titulo,
    subtitulo,
    statusNome,
    atendenteNome,
    tipoNome,
    descriptionContent,
    editorProps,
    timelineEventos,
    anexosCard,
    anexosCardRef,
}) {
    return (
        <div className="chamado-page">
            <div className="chamado-page-main">
                <ChamadoHeader
                    titulo={titulo}
                    subtitulo={subtitulo}
                    statusNome={statusNome}
                    atendenteNome={atendenteNome}
                    tipoNome={tipoNome}
                />
                <div className="chamado-card-wrap">
                    <ChamadoDescription>{descriptionContent}</ChamadoDescription>
                </div>
                <ChamadoEditor
                    value={editorProps.value}
                    onChange={editorProps.onChange}
                    onInserir={editorProps.onInserir}
                    onAnexar={editorProps.onAnexar}
                    marcado={editorProps.marcado}
                    onMarcadoChange={editorProps.onMarcadoChange}
                    comentarioInterno={editorProps.comentarioInterno}
                    onComentarioInternoChange={editorProps.onComentarioInternoChange}
                    iaHabilitada={false}
                    onSugerirResposta={() => {}}
                    onReverResposta={() => {}}
                    onSugerirProximosPassos={() => {}}
                    sugestaoRespostaLoading={false}
                    reverRespostaLoading={false}
                    proximosPassosLoading={false}
                    onAtualizar={editorProps.onAtualizar}
                />
                <ChamadoTimeline eventos={timelineEventos} />
            </div>
            <ChamadoSidebarSolicitante statusNome={statusNome} anexosCard={anexosCard} anexosCardRef={anexosCardRef} />
        </div>
    );
}

export default ChamadoPageSolicitante;
